module.exports = __webpack_public_path__ + "img/en.dba4ee54.svg";